import { type ExtensionApi } from '../../../core/extension';
import {
  type Layer,
  type StandardChartLayerSpec,
  defineStandardChartLayer
} from '../../../core/layer';
import DEFINE from '../../../util/DEFINE';

const visInfo: Layer['visInfo'] = {
  id: 'shadowBar',
  name_en: 'shadowBar',
  name_zh: '影子柱状图',
  types_en: [],
  purpose_en: [],
  purpose_zh: [],
  standers: '',
  rules: {
    x: amount => amount > 1,
    y: amount => amount > 1,
    z: amount => amount > 1
  },
  /** 保证和 Spec.encoding 字段一致 */
  parameters: {
    x: {
      itemType: [DEFINE.STR],
      category: DEFINE.SINGLE
    },
    y: {
      itemType: [DEFINE.NUMBER],
      category: DEFINE.SINGLE
    },
    z: {
      itemType: [DEFINE.STR],
      category: DEFINE.SINGLE
    }
  }
};

/**
 * ECharts 的配置项
 * @see https://echarts.apache.org/zh/option.html#series-line
 */
// type EChartsPieSeries = {
//   roseType?: unknown;
//   radius?: unknown;
// };

export interface Spec extends StandardChartLayerSpec {
  encoding: {
    x: string;
    y: string;
    z: string;
  };
}

export const shadowBar = defineStandardChartLayer<Spec>({
  type: visInfo.id,
  isIndependentLayer: true,
  visInfo,
  render(api, spec) {
    const { data: dataArray, util: utils } = api;
    const {
      dataIndex = 0,
      encoding: { x, y, z }
    } = spec;
    const data = dataArray[dataIndex];
    const transformData = utils.dataTransform.transform(data.values.slice(), [
      { type: 'sort', field: x, order: 'ascending' }
    ]);
    const { x: xAxisData } = utils.dataEncoding.encoding(transformData, {
      x: {
        field: x,
        transforms: [{ type: 'deDuplication' }, { type: 'sort', order: 'ascending' }]
      },
      y: { field: y[0], transforms: [{ type: 'toNumeric' }] },
      z: { field: z, transforms: [{ type: 'deDuplication' }] }
    });
    const zAxis = Array.from(new Set(dataArray[0].values.map(item => item[z])));
    const colors = ['#4D5999', 'rgba(77,89,153,0.2)'];
    const series = zAxis.map((item, index) => {
      return {
        name: item,
        data: dataArray[0].values.filter(ele => ele[z] === item).map(item => item[y]),
        type: 'bar',
        barGap: '-50%',
        itemStyle: {
          borderColor: colors[index],
          borderWidth: 1
        }
      };
    });
    /**
     *  配置Series
     * @returns
     */
    function configureSeriesOption() {
      return {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        xAxis: {
          show: true,
          type: 'category',
          data: xAxisData,
          axisPointer: {
            show: true,
            type: 'shadow',
            shadowStyle: {
              color: 'rgba(172,198,251)',
              opacity: 0.3
            }
          }
        },
        yAxis: {
          show: true,
          type: 'value',
          __dataIndex: 0,
          __encodeField: [y]
        },
        color: ['rgba(77,89,153,0.8)', 'rgba(77,89,153,0.2)'],
        series
      };
    }
    // * -------------------------- chart
    return renderApi => {
      const renderParams = {
        option: renderApi.mergeChartOptionProxy(configureSeriesOption())
      };
      renderApi.renderLegendProxy(renderParams.option.legend.data);
      renderApi.renderChartProxy(renderParams);
    };
  }
});
